var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wg-image',{attrs:{"url":_vm.url,"styleObject":Object.assign({type: _vm.type}, _vm.realStyle)}})
}
var staticRenderFns = []

export { render, staticRenderFns }